import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import PageLanding from './pages/PageLanding';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'styled-components';

const theme = {}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <PageLanding />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
